import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McoLedgerLineList } from '../mcoLedgerLine/McoLedgerLineList';

export const McoLedgerDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'ledgerLines',
      label: 'Lines',
      content: <McoLedgerLineList mcoLedger={entityObj} />,
    },
    {
      id: 'vals',
      label: 'Validations',
      content: <ValList parentEntity="MCO_LEDGER" parentEntityId={entityObj.id} />,
    },
    {
      id: 'soxControlsTab',
      label: 'SOX Controls',
      content: <EntityControlList parentEntity="MCO_LEDGER" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
